import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  contentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    width: '100%',
    marginBottom: 32
  },
  promoImg: {
    width: '100%',
    marginTop: 24
  },
  contentContainer: {
    width: '100%',
    marginBottom: 32
  },
  paragraph: {
    marginBottom: 16,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: '32px 0'
  },
  warning: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFE082',
    marginBottom: 24
  },
  warningTitle: {
    fontWeight: 700,
    marginBottom: 8
  },
  legend: {
    display: 'block',
    paddingTop: 8,
    fontSize: 14,
    color: '#9a9a9a'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  buttonContainer: {
    padding: 5
  },
  submitButton: {
    padding: '16px 64px',
    borderRadius: 30
  }
}))
